(function() {
    'use strict';
    angular
        .module('valueconnectApp')
        .factory('AppraisalOrderModal', AppraisalOrderModal);

    AppraisalOrderModal.$inject = ['$q','$uibModal', '$mdDialog', '$state', '$translate', 'AppraisalOrder', 'AppraisalReport', 'DynamicForm', 'AlertService', 'Refund'];

    function AppraisalOrderModal ($q,$uibModal, $mdDialog, $state, $translate, AppraisalOrder, AppraisalReport, DynamicForm, AlertService, Refund) {
        var service = {
            openAppraisalOrderContactDialog: openAppraisalOrderContactDialog,
            openLenderContactDialog: openLenderContactDialog,
            requestQuote: requestQuote,
            openAcceptDialog: openAcceptDialog,
            openDeclinedDialog: openDeclinedDialog,
            openPaymentDialog: openPaymentDialog,
            openAppraisalOrderChangeRequestDialog: openAppraisalOrderChangeRequestDialog,
            scheduleVisit: scheduleVisit,
            completeVisit: completeVisit,
            restoreCancelledOrder: restoreCancelledOrder,
            thirdPartyUpload: thirdPartyUpload,
            assignCosigner: assignCosigner,
            assignAppraiser: assignAppraiser,
            quoteRequests: quoteRequests,
            redirectOrder: redirectOrder,
            openCcrAppraisalOrderChangeRequestDialog: openCcrAppraisalOrderChangeRequestDialog,
            openCancelAppraisalOrderDialog: openCancelAppraisalOrderDialog,
            changeDueDate: changeDueDate,
            changeUnderwriter: changeUnderwriter,
            sendReportBack: sendReportBack,
            addVCNote: addVCNote,
            changeOrderState: changeOrderState,
            openRefundDialog: openRefundDialog,
        };

        var requestQuoteTranslations = $translate([
            'valueconnectApp.appraisalOrder.requestQuote.title',
            'valueconnectApp.appraisalOrder.requestQuote.body',
            'valueconnectApp.appraisalOrder.requestQuote.continue',
            'entity.action.cancel'
        ]);

        var modalInstance = null;
        return service;

        function resetModal() {
            modalInstance = null;
        }

        function createDialogInstance(templateUrl, controller, resolveObj, localsObj) {
            if (modalInstance !== null) return $q.when(null);
            modalInstance = $mdDialog.show({
                templateUrl: templateUrl,
                controller: controller,
                controllerAs: 'vm',
                animation: true,
                backdrop: 'static',
                size: 'lg',
                clickOutsideToClose: true,
                resolve: resolveObj,
                locals: localsObj
            }).finally(resetModal).then(function (result) {
                $state.reload();
                return result;
            }, function (reason) {
                // A dialog can close by handing off to another one (e.g. assign appraiser -> quote requests).
                // resetModal has already run, so the next dialog can open; the caller sees a plain cancel.
                if (reason && angular.isFunction(reason.followUp)) {
                    reason.followUp();
                    return $q.defer().promise;
                }
                // Pass errors on to the caller. Leave a plain cancel unsettled so that no success or error toast fires.
                return reason && reason.error ? $q.reject(reason) : $q.defer().promise;
            });
            return modalInstance;
        }

        // Create Property Access Contact
        function openAppraisalOrderContactDialog (appraisalOrder) {
            return createDialogInstance(
                'app/entities/appraisal-order-contact/appraisal-order-contact-dialog.html',
                'AppraisalOrderContactDialogController',
                {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('address');
                        $translatePartialLoader.addPart('appraisalOrderContact');
                        $translatePartialLoader.addPart('appraisalContactRole');
                        $translatePartialLoader.addPart('contact');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            id: null,
                            appraisalReportSendToEmailAddress: null,
                            disabled: false,
                            appraisalOrder: null,
                            client: appraisalOrder.clientContact,
                            contact: {
                                officeAddress: {}
                            }
                        };
                    }
                }
            );
        }

        // Create Lender Contact
        function openLenderContactDialog (lenderId, showLender) {
            return createDialogInstance(
                'app/entities/lender-contact/lender-contact-dialog.html',
                'LenderContactDialogController',
                {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('address');
                        $translatePartialLoader.addPart('appraisalOrderContact');
                        $translatePartialLoader.addPart('appraisalContactRole');
                        $translatePartialLoader.addPart('contact');
                        $translatePartialLoader.addPart('file');
                        $translatePartialLoader.addPart('lenderContact');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            id: null,
                            appraisalReportSendToEmailAddress: null,
                            disabled: false,
                            lenderId: lenderId,
                            contact: {}
                        };
                    }
                },
                {
                    showLender: showLender || false,
                    operation: "create"
                }
            );
        }

        // Request Manual Quote
        function requestQuote(appraisalOrder, ev) {
            return requestQuoteTranslations.then(function(translations) {
                var title = translations['valueconnectApp.appraisalOrder.requestQuote.title'];
                var body = translations['valueconnectApp.appraisalOrder.requestQuote.body'];
                var cancel = translations['entity.action.cancel'];
                var ok = translations['valueconnectApp.appraisalOrder.requestQuote.continue'];

                var dialog = $mdDialog.confirm()
                    .title(title).ariaLabel(title)
                    .htmlContent(body)
                    .targetEvent(ev)
                    .ok(ok)
                    .cancel(cancel);

                return $mdDialog.show(dialog).then(function(result) {
                    return AppraisalOrder.requestQuote({id: appraisalOrder.id}, null).$promise;
                });
            });
        }

        // Accept Assignment
        function openAcceptDialog(appraisalOrder) {
            return createDialogInstance(
                'app/entities/appraisal-order/appraisal-order-accept-assignment-dialog.html',
                'AppraisalOrderAcceptAssignmentDialogController',
                {},
                { order: appraisalOrder }
            );
        }

        // Decline Assignment
        function openDeclinedDialog (appraisalOrder) {
            return createDialogInstance(
                'app/entities/declined/declined-dialog.html',
                'DeclinedDialogController',
                {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('address');
                        $translatePartialLoader.addPart('appraisalOrderContact');
                        $translatePartialLoader.addPart('appraisalContactRole');
                        $translatePartialLoader.addPart('contact');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            appraisalOrder: appraisalOrder
                        };
                    }
                }
            );
        }

        // Make Payment
        function openPaymentDialog (split) {
            return createDialogInstance(
                'app/entities/payment/payment-dialog.html',
                'PaymentDialogController',
                {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('payment');
                        $translatePartialLoader.addPart('enumPaymentMethod');
                        $translatePartialLoader.addPart('enumPaymentStatus');
                        $translatePartialLoader.addPart('paymentProfile');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            method: null,
                            amount: split.splitAmount,
                            transactionId: null,
                            transactionDate: null,
                            paymentStatus: null,
                            id: null,
                            quoteSplitId: split.id
                        };
                    }
                }
            );
        }

        // Create Change Request
        function openAppraisalOrderChangeRequestDialog (state, appraisalOrder, changeRequest) {
            return createDialogInstance(
                'app/entities/appraisal-order-change-request/appraisal-order-change-request-appraiser-dialog.html',
                'AppraisalOrderChangeRequestAppraiserDialogController',
                {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            state: state,
                            appraisalOrder: appraisalOrder,
                            appraisalOrderChangeRequest: changeRequest
                        };
                    }
                }
            );
        }

        // View Change Request
        function openCcrAppraisalOrderChangeRequestDialog (appraisalOrder, changeRequest, showDeclineAndReassign) {
            return createDialogInstance(
                'app/entities/appraisal-order-change-request/appraisal-order-change-request-dialog.html',
                'AppraisalOrderChangeRequestDialogController',
                {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            appraisalOrder: appraisalOrder,
                            appraisalOrderChangeRequest: changeRequest
                        };
                    },
                    showDeclineAndReassign: function() {
                        return showDeclineAndReassign;
                    }
                }
            );
        }

        // Cancal Appraisal Order
        function openCancelAppraisalOrderDialog(appraisalOrder) {
            return createDialogInstance(
                'app/entities/appraisal-order/cancel-appraisal-order-dialog.html',
                'CancelAppraisalOrderDialogController',
                {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            id: appraisalOrder.id,
                            reason: null
                        };
                    }
                }
            );
        }

        // Schedule Inspection
        function scheduleVisit(appraisalOrder) {
            return createDialogInstance(
                'app/entities/appraisal-order/schedule-visit-dialog.html',
                'ScheduleVisitDialogController',
                {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    order: function () {
                        return appraisalOrder;
                    }
                }
            );
        }

        /**
         * Show dialog to complete the appraisal visit
         * @param  {Object}  appraisalOrder The appraisal order to update
         * @param  {Event}   ev             The click event that triggered the modal
         * @return {Promise}                A promise that will either be cancelled, or resolved with the updated appraisal order
         */
        function completeVisit(appraisalOrder, ev) {
            var dialog = $mdDialog.show($mdDialog.confirm()
                .title('Complete Inspection')
                .textContent('Are you sure you want to mark your inspection for this appraisal as completed?')
                .ariaLabel('Complete Inspection')
                .targetEvent(ev)
                .ok('COMPLETE INSPECTION')
                .cancel('CANCEL'));

            // Send update request to server once dialog has been resolved
            return dialog.then(function () {
                return AppraisalReport.completeVisit({ appraisalOrderId: appraisalOrder.id }).$promise.then(function (data) {
                    return data;
                });
            });
        }

        /**
         * Show a confirmation dialog then call endpoint to delete existing forms on the specified
         * report and use the third party upload form
         * @param  {Object}  appraisalReport The target appraisal report
         * @param  {Event}   ev             The click event that triggered the modal
         * @return {Promise}                A promise that will be resolved with the created form
         */
        function thirdPartyUpload(appraisalReport, ev) {
            var translationKeys = ['description', 'warning', 'instructions'].map(function(suffix) {
                return 'valueconnectApp.appraisalReport.useThirdParty.' + suffix;
            });

            // Only show warning if the report has already been started
            if(appraisalReport.started === false) translationKeys.splice(1, 1);

            // Get a translation for the dialog message
            return $translate(translationKeys).then(function(translations) {
                var message = Object.keys(translations).map(function(key) {
                    return translations[key];
                }).join('');

                // Show the dialog
                return $mdDialog.show($mdDialog.confirm()
                    .title('Third Party Report Sender')
                    .htmlContent(message)
                    .ok('OK')
                    .cancel('CANCEL')
                    .targetEvent(ev)
                    .clickOutsideToClose(true)
                ).then(function() {
                    // Replace existing forms with third party form
                    return DynamicForm.useThirdParty({reportId: appraisalReport.id}, null).$promise;
                });
            });
        }

        // Assign Cosigner
        function assignCosigner(appraisalOrder, cosigners) {
            return createDialogInstance(
                'app/entities/appraisal-order/appraisal-order-assign-cosigner-dialog.html',
                'AppraisalOrderAssignCosignerDialogController',
                {
                    suggestedAppraisers: ['AppraiserUser', function(AppraiserUser) {
                        return cosigners || AppraiserUser.getCosigners({orderId: appraisalOrder.id}).$promise;
                    }]
                },
                { order: appraisalOrder }
            );
        }

        // Assign Appraiser
        // @param assignType - ASSIGN_APPRAISER, REASSIGN_APPRAISER, PREASSIGN_APPRAISER
        function assignAppraiser(appraisalOrder, assignType) {
            return createDialogInstance(
                'app/entities/appraisal-order/appraisal-order-assign.html',
                'AppraisalOrderAssignController',
                {
                    suggestedAppraisers: ['AppraiserUser', function(AppraiserUser) {
                        return AppraiserUser.getSuggested({id: appraisalOrder.id}).$promise;
                    }],
                    eligibleAppraisers: ['AppraiserUser', function(AppraiserUser) {
                        return AppraiserUser.getEligible({id: appraisalOrder.id}).$promise;
                    }],
                    independentAppraisers: ['AppraiserUser', function(AppraiserUser) {
                        return AppraiserUser.getIndependent({id: appraisalOrder.id}).$promise;
                    }],
                },
                { order:  appraisalOrder, assignType: assignType }
            );
        }

        // Quote Requests
        function quoteRequests(appraisalOrder, partialCoverageAppraisers, regionalCoverageAppraisers) {
            return createDialogInstance(
                'app/entities/appraisal-order/appraisal-order-quote-requests.html',
                'AppraisalOrderQuoteRequestsController',
                {
                    suggestedAppraisers: ['AppraiserUser', function(AppraiserUser) {
                        return AppraiserUser.getSuggested({id: appraisalOrder.id}).$promise;
                    }],
                    eligibleAppraisers: ['AppraiserUser', function(AppraiserUser) {
                        return AppraiserUser.getEligible({id: appraisalOrder.id}).$promise;
                    }],
                    independentAppraisers: ['AppraiserUser', function(AppraiserUser) {
                        return AppraiserUser.getIndependent({id: appraisalOrder.id}).$promise;
                    }],
                },
                { order:  appraisalOrder, partialCoverageAppraisers: partialCoverageAppraisers || [], regionalCoverageAppraisers: regionalCoverageAppraisers || [] }
            );
        }

        // Redirect Order to Another Lender
        function redirectOrder(appraisalOrder) {
            return createDialogInstance(
                'app/entities/appraisal-order/appraisal-order-redirect-dialog.html',
                'AppraisalOrderRedirectDialogController',
                {},
                {appraisalOrder: angular.copy(appraisalOrder)}
            );
        }

        // Restore cancelled order
        function restoreCancelledOrder(appraisalOrder) {
            return createDialogInstance(
                'app/entities/appraisal-order/appraisal-order-restore-dialog.html',
                'AppraisalOrderRestoreDialogController',
                {},
                {appraisalOrder: angular.copy(appraisalOrder)}
            );
        }

        // Send Report Back to Appraiser
        function sendReportBack(appraisalReport) {
            return createDialogInstance(
                'app/entities/appraisal-report/appraisal-report-send-back-dialog.html',
                'AppraisalReportSendBackDialogController',
                {},
                {appraisalReport: angular.copy(appraisalReport)}
            );
        }

        // Change Appraisal Due Date
        function changeDueDate(appraisalOrder) {
            return createDialogInstance(
                'app/entities/appraisal-order/appraisal-order-change-duedate-dialog.html',
                'AppraisalOrderChangeDueDateDialogController',
                {},
                { appraisalOrder: angular.copy(appraisalOrder) }
            );
        }

        // Change the lender underwriter contact
        function changeUnderwriter(appraisalOrder) {
            return createDialogInstance(
                'app/entities/appraisal-order/appraisal-order-change-underwriter-dialog.html',
                'AppraisalOrderChangeUnderwriterDialogController',
                {},
                { appraisalOrder: angular.copy(appraisalOrder) }
            );
        }

        // Create Internal Appraisal Note
        function addVCNote(appraisalOrder) {
            return createDialogInstance(
                'app/entities/vc-note/vc-note-dialog.html',
                'VCNoteDialogController',
                {},
                {
                    entity: {
                        note: null,
                        appraisalOrderId: appraisalOrder.id,
                        files: []
                    }
                }
            );
        }

        function changeOrderState(appraisalOrder) {
            return createDialogInstance(
                'app/entities/appraisal-order/appraisal-order-change-state.html',
                'AppraisalOrderChangeStateController',
                {},
                {
                    appraisalOrder: appraisalOrder,
                }
            )
        }

        function openRefundDialog(split, appraisalOrder) {
            var paymentSplit = split.paymentSplits[0];
            var quote = null;

            for (var i = 0; i < appraisalOrder.appraisalReports.length; i++) {
                var report = appraisalOrder.appraisalReports[i];
                if (report.quote) {
                    var quoteSplits = report.quote.quoteSplits;
                    for (var j = 0; j < quoteSplits.length; j++) {
                        if (quoteSplits[j].id === split.id) {
                            quote = report.quote;
                            break;
                        }
                    }
                    if (quote) break;
                }
            }

            var taxRate = 1;
            if (quote && quote.subTotal && quote.subTotalTax && quote.subTotal > 0) {
                taxRate = (quote.subTotal + quote.subTotalTax) / quote.subTotal;
            }

            var paymentAmount = paymentSplit.amount;

            var lineItems = [];
            var totalAppraiserCost = 0;
            var totalRetailPrice = 0;
            if (quote && quote.lineItems) {
                quote.lineItems.forEach(function(item) {
                    // This skips $0 Price lines, so their appraiser cost is left out of totalAppraiserCost.
                    // "Set Order Pricing" can drop a line's Price to $0 while its appraiser cost stays, but it only
                    // works on invoice orders, which have no card or Stripe payment to refund. We don't expect
                    // "Set Order Pricing" to be opened up to card or Stripe orders, which is why this is left as is.
                    // If it ever is, include $0 Price lines here or the maximum appraiser refund will be too low.
                    if (item.price !== 0 && item.regionalProductProductType !== 'PAYMENT_REFUND') {
                        lineItems.push({
                            name: item.regionalProductProductType,
                            retailPrice: item.price,
                            appraiserCost: item.appraiserPrice,
                            quantity: item.quantity,
                            tax: item.tax || 0,
                            appraiserTax: item.appraiserTax || 0
                        });
                        totalRetailPrice += item.price;
                        totalAppraiserCost += (item.appraiserPrice || 0);
                    }
                });
            }

            var vcFee = Math.round((totalRetailPrice - totalAppraiserCost) * 100) / 100;

            var deferred = $q.defer();
            Refund.getPaymentSummary({ paymentId: paymentSplit.paymentId }, function(summary) {
                var alreadyRefundedTotal = summary.totalRefunded || 0;
                var alreadyRefundedVcFee = summary.totalVcFeeRefunded || 0;
                var alreadyRefundedAppraiser = summary.totalAppraiserRefunded || 0;
                var alreadyRefundedTax = summary.totalTaxRefunded || 0;
                var alreadyRefundedSubtotal = Math.round((alreadyRefundedTotal - alreadyRefundedTax) * 100) / 100;

                var remainingPayment = Math.max(paymentAmount - alreadyRefundedTotal, 0);
                var maxSubtotal = Math.round((remainingPayment / taxRate) * 100) / 100;

                var remainingVcFee = Math.max(vcFee - alreadyRefundedVcFee, 0);
                var remainingAppraiserCost = Math.max(totalAppraiserCost - alreadyRefundedAppraiser, 0);
                var maxVcFee = Math.round(Math.min(remainingVcFee, maxSubtotal) * 100) / 100;
                var maxAppraiserCost = Math.round(Math.min(remainingAppraiserCost, maxSubtotal) * 100) / 100;

                var result = createDialogInstance(
                    'app/entities/payment/refund-dialog.html',
                    'RefundDialogController',
                    {},
                    {
                        paymentId: paymentSplit.paymentId,
                        stripePayeeEmail: paymentSplit.stripePayeeEmail || null,
                        maxSubtotal: maxSubtotal,
                        splitRole: split.role,
                        orderState: appraisalOrder.state,
                        taxRate: Math.round(taxRate * 10000) / 10000,
                        lineItems: lineItems,
                        totalRetailPrice: totalRetailPrice,
                        totalAppraiserCost: totalAppraiserCost,
                        maxVcFee: maxVcFee,
                        maxAppraiserCost: maxAppraiserCost,
                        subTotalTax: (quote && quote.subTotalTax) || 0,
                        feeProposed: (quote && (quote.feePaid || quote.feeProposed)) || 0,
                        feeProposedTax: (quote && (quote.feePaidTax || quote.feeProposedTax)) || 0,
                        alreadyRefundedTotal: alreadyRefundedTotal,
                        alreadyRefundedSubtotal: alreadyRefundedSubtotal,
                        alreadyRefundedVcFee: alreadyRefundedVcFee,
                        alreadyRefundedAppraiser: alreadyRefundedAppraiser,
                        alreadyRefundedTax: alreadyRefundedTax
                    }
                );
                deferred.resolve(result);
            }, function(error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }
    }
})();
